import * as React           from 'react';

import {ReactGAGuestModal}  from "@Common/libs/ga/xd-react-ga";
import {cs}                 from '@Common/react/chain-services';
import {Invoke}             from '@Common/react/invoke';
import {Static2}            from "@Common/react/static-2";
import {UseState}           from '@Common/react/use-state';
import {ConfirmDialog}      from '@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog';
import {ModalService3}      from '@Common/ui-components/modal-service-3/modal-service-3';
import {LoadingSpinner}     from '@Common/ui-components/photo-dashboard/components/loading-spinner';
import {parseUrlQuery}      from '@Common/utils/parse-url-query';
import {CreateAccountModal} from './create-account-content/create-account-modal';
import {GuestSigninModal}   from './guest-signin-content/guest-signin-modal';

import "./guest-modal.scss";

export const GuestModal = ({required=false, content, next: rootNext}) => cs(
    ["query", (_, next) => next(parseUrlQuery(location.search))],
    ["apiError", ({}, next) => UseState({initValue: "", next})],
    ["contentState", ({query}, next) => UseState({
        initValue: {
            loading: false,
            content: content || query?.modal
        },
        next,
    })],
    ["values", ({}, next) => UseState({
        initValue: {
            email: '',
            firstName: '',
            lastName: '',
            password: '',
            confirmPassword: '',
        },
        next,
    })],
    ["modal", ({query, contentState}, next) => ModalService3({
        initShow: content === query?.modal,
        xdQaName: "Guest Modal",
        width: 480,
        rootNext,
        onClose: () => contentState.onChange({loading: false, content}),
        xToClose: !required && !contentState.value.loading,
        ignorePassiveClose: required || contentState.value.loading,
        next
    })],
    ["confirmCloseDialog", ({}, next) => ConfirmDialog({next})],
    ({contentState}, next) => (
        Invoke({
            action: () => ReactGAGuestModal({type: contentState.value.content}),
            next,
        })
    ),
    ["domRef", (_, next) => Static2({next})],
    ({apiError, contentState, values, domRef, modal}) => (
        contentState.value.loading ? (
            <div className="guest-modal-gm88">
                <div className="spinner">
                    <LoadingSpinner text="Loading..."/>
                </div>
            </div>
        ) : contentState.value.content === "newAccount" ? (
            CreateAccountModal({
                apiError,
                values,
                content: contentState,
                domRef,
            })
        ) : (
            GuestSigninModal({
                apiError,
                values,
                content: contentState,
                domRef,
                closeModal: modal.close,
            })
        )
    )
)
